import { useRef } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Button from "../../../../components/Buttons/Button";
import BrandMultilineField from "./BrandMultilineField";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  BRAND_SETUP_GENERATION_ATTACH_PDF,
  BRAND_SETUP_GENERATION_PROMPT_LABEL,
  BRAND_SETUP_GENERATION_PROMPT_PLACEHOLDER,
  BRAND_SETUP_GENERATION_REMOVE_PDF,
} from "../../../../i18n/keysTranslations";
import { BRAND_SOURCE_PDF_MIME } from "../utils/brandSourcePdf";

export const BrandGenerationSources = ({
  prompt = "",
  onPromptChange = () => {},
  pdfFile = null,
  onPdfSelected = () => {},
  onPdfRemoved = () => {},
  disabled = false,
  errorMessage = "",
}) => {
  const { t } = useTranslationApp();
  const inputRef = useRef(null);

  const onFileInputChange = (event) => {
    const [file] = event.target.files || [];
    if (file) onPdfSelected({ file });
    event.target.value = "";
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            mb: 0.5,
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "text.primary" }}
          >
            {t(BRAND_SETUP_GENERATION_PROMPT_LABEL)}
          </Typography>
          <input
            ref={inputRef}
            type="file"
            hidden
            accept={`.pdf,${BRAND_SOURCE_PDF_MIME}`}
            onChange={onFileInputChange}
          />
          <Button
            type="button"
            color="secondary"
            tooltip={t(BRAND_SETUP_GENERATION_ATTACH_PDF)}
            ariaLabel={t(BRAND_SETUP_GENERATION_ATTACH_PDF)}
            onClick={() => inputRef.current?.click()}
            disabled={disabled}
            sx={{
              minWidth: "auto !important",
              width: "38px !important",
              height: "38px !important",
              px: "10px !important",
            }}
          >
            <AttachFileIcon sx={{ fontSize: "18px" }} />
          </Button>
        </Box>
        <BrandMultilineField
          name="brandGenerationPrompt"
          value={prompt}
          onChange={(event) => onPromptChange({ value: event.target.value })}
          placeholder={t(BRAND_SETUP_GENERATION_PROMPT_PLACEHOLDER)}
          disabled={disabled}
          minRows={3}
        />
      </Box>

      {pdfFile && (
        <Box sx={{ display: "flex" }}>
          <Chip
            label={pdfFile.name}
            onDelete={disabled ? undefined : onPdfRemoved}
            aria-label={t(BRAND_SETUP_GENERATION_REMOVE_PDF, {
              name: pdfFile.name,
            })}
            sx={{
              "& .MuiChip-label": {
                pl: 0,
              },
            }}
          />
        </Box>
      )}

      {errorMessage ? (
        <Typography variant="caption" sx={{ color: "error.main" }}>
          {errorMessage}
        </Typography>
      ) : null}
    </Box>
  );
};

export default BrandGenerationSources;
